import { getTodayPartsInJakarta } from "./utils/date";

// Urut menurut jam MULAI. Format wajib berspasi ("19.00 - 20.30", bukan "19.00-20.30"):
// teks sesi ikut jadi kunci baris `attendance_recap`, jadi beda ejaan = sesi berbeda =
// riwayat absensi & gaji terpecah dua baris.
// CATATAN: Manajemen Kelas menurunkan daftar sesinya dari DATA (endpoint
// /api/classes/meta/sessions), sedangkan daftar ini tetap di kode. Keduanya bisa
// berselisih - kalau ada jam baru, tambahkan di sini juga.
export const SESSION_OPTIONS = [
  "08.30 - 10.00",
  "10.15 - 11.45",
  "13.00 - 15.00",
  "14.00 - 15.30",
  "16.00 - 17.30",
  "18.45 - 20.15",
  "19.00 - 20.30",
  "20.30 - 21.45"
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const YEARS = ["2026", "2027"];

export function todayParts() {
  return getTodayPartsInJakarta();
}

export function money(num) {
  const value = Number(num || 0);
  if (!value) return "-";

  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0
  }).format(value);
}

export function csvDownload(filename, content) {
  const blob = new Blob([content], {
    type: "text/csv;charset=utf-8;"
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
